import api from 'api';
import type { RawAudit, RawHourAuditChanges } from 'types/audits';

export const auditsApi = {
  getHourHistory: (id: number): Promise<Array<RawAudit<RawHourAuditChanges>>> => {
    return api.get(`hours/${id}/audits`);
  },
};
